<template>
  <v-app id="inspire" class="bodyPadding"> 
    <mo-header></mo-header>
    <v-content>
		<package-head></package-head>		
		<package-list></package-list>
    </v-content>
  </v-app>
</template>

<script>

	import PackageHead from './Header.vue';	
	import PackageList from './List.vue';
	export default {
		data () {
			return {
		
			}		
		},
		components: {
          PackageHead,			
          PackageList
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>